<mat-card>
  <mat-card-title>Informações e procedimentos a serem realizados pelo aluno PAADES</mat-card-title>
  <mat-card-content>
    <ol>
      <li>Você poderá se inscrever em uma ou mais disciplinas liberadas pelo departamento.</li>
      <li>Sua inscrição será aprovada pelo departamento em uma única disciplina.</li>
      <li>
        Após sua inscrição ser aprovada pelo departamento, baixar o modelo do plano de atividades no sistema e procurar
        o docente responsável pela disciplina para definir com ele as atividades que você realizará e carga horária
        prevista. Observar que caso defina ministrar aula, não poderá ultrapassar 20% da carga horária da disciplina. O
        docente da disciplina deverá estar presente.
      </li>
      <li>
        O aluno deve lançar no SISPAADES, a carga horária prevista das atividades que foram definidas com o docente da
        disciplina e imprimir o documento gerado para as providências de assinaturas do docente da disciplina e de seu
        orientador.
      </li>
      <li>
        Após aprovado o plano de atividades e com as assinaturas você deve realizar o upload em PDF e entregar o plano
        via SISPAADES.
      </li>
      <li>
        Após o plano de atividades ser liberado pelo chefe do departamento, o aluno será inserido na base de dados do
        SISGRAD, isso é automático pelo sistema.
      </li>
      <li>
        Você iniciará o PAADES somente após liberação do plano de atividades pelo chefe do departamento. Caberá a você
        acompanhar essas aprovações. Entre em contato com o docente da disciplina e/ou departamento para solicitar.
      </li>
      <li>
        O chefe do departamento deve vincular o aluno na oferta do sistema do SISGRAD para o período letivo, como também
        no término da disciplina, consolidar a mesma no SISGRAD.
      </li>
      <li>
        Após a finalização da disciplina, o docente responsável da disciplina deve entrar no SISPAADES para lançar a
        carga horária efetiva no plano de atividades, ou seja, aquela que realmente você cumpriu.
      </li>
      <li>
        Você deve baixar no sistema, o modelo de relatório e preencher e após fazer o upload na opção de entrega desse
        relatório no SISPAADES.
      </li>
      <li>
        Após o upload do relatório o docente responsável da disciplina deve aprová-lo e o chefe do departamento
        homologará, ambos via SISPAADES.
      </li>
      <li>
        Você terá direito ao certificado do PAADES, porém somente após relatório aprovado, homologado e finalização da
        disciplina. Você é responsável pelo acompanhamento desses trâmites.
      </li>
      <li>
        É importante que você acompanhe esses 2(dois) passos para ter o certificado: aprovação, homologação do relatório
        e finalização da disciplina.
      </li>
    </ol>
  </mat-card-content>
</mat-card>
